(function () {
  'use strict';

  function initCarousel(root) {
    var track = root.querySelector('[data-vt-track]');
    var prevBtn = root.querySelector('[data-vt-prev]');
    var nextBtn = root.querySelector('[data-vt-next]');
    var dots = root.querySelectorAll('[data-vt-dot]');
    var cards = root.querySelectorAll('.vt-card');

    if (!track) return;

    function cardStep() {
      if (cards.length > 1) {
        var step = cards[1].offsetLeft - cards[0].offsetLeft;
        if (step > 0) return step;
      }
      if (cards.length > 0) {
        return cards[0].getBoundingClientRect().width;
      }
      return track.clientWidth;
    }

    function currentIndex() {
      var step = cardStep();
      if (!step) return 0;
      return Math.round(track.scrollLeft / step);
    }

    function updateUI() {
      var maxScroll = track.scrollWidth - track.clientWidth;

      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
      if (nextBtn) nextBtn.disabled = maxScroll <= 4 || track.scrollLeft >= maxScroll - 4;

      var index = currentIndex();
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function goToIndex(index) {
      var step = cardStep();
      var maxIndex = cards.length - 1;
      var clamped = Math.max(0, Math.min(index, maxIndex));
      track.scrollTo({ left: clamped * step, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToIndex(currentIndex() - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToIndex(currentIndex() + 1);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goToIndex(i);
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateUI();
        ticking = false;
      });
    });

    window.addEventListener('resize', updateUI);
    window.addEventListener('load', updateUI);

    updateUI();
  }

  function init() {
    var carousels = document.querySelectorAll('[data-vt-carousel]');
    carousels.forEach(function (el) {
      initCarousel(el.closest('.vt'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();